/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Analyze_DataInputs */



/**
* | output |
* | --- |
* | "Analyze spreadsheets and data" |
*
* @param {Onboarding_Usage_Analyze_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_analyze_data = /** @type {((inputs?: Onboarding_Usage_Analyze_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Analyze_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tabellen und Daten analysieren")
	return /** @type {LocalizedString} */ ("Analyze spreadsheets and data")
});